var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2898 4.34369L1.81978 18.4837C1.64514 18.7861 1.55274 19.129 1.55177 19.4782C1.55079 19.8274 1.64127 20.1708 1.8142 20.4742C1.98714 20.7776 2.2365 21.0304 2.53748 21.2075C2.83847 21.3846 3.18058 21.4799 3.52978 21.4837H20.4698C20.819 21.4799 21.1611 21.3846 21.4621 21.2075C21.7631 21.0304 22.0124 20.7776 22.1854 20.4742C22.3583 20.1708 22.4488 19.8274 22.4478 19.4782C22.4468 19.129 22.3544 18.7861 22.1798 18.4837L13.7098 4.34369C13.5315 4.0498 13.2805 3.80681 12.981 3.63818C12.6814 3.46954 12.3435 3.38095 11.9998 3.38095C11.656 3.38095 11.3181 3.46954 11.0186 3.63818C10.7191 3.80681 10.468 4.0498 10.2898 4.34369Z",
    stroke: "#FFB900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.4837V13.4837",
    stroke: "#FFB900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4837H12.01",
    stroke: "#FFB900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.3f292f1d725318172e2eabfc261f5f47.svg";
export { ForwardRef as ReactComponent };